import { lineColors } from "../constants";
import { ANALYTICS_MEASURE_TYPE, ISignalDataResponse, IChartDataSignal } from "../interfaces";

const calculateXValues = (xStart: number, xEnd: number, count: number): number[] => {
  const dX = (xEnd - xStart) / (count - 1);
  return Array.from({ length: count }, (_, i) => xStart + i * dX);
};

type ComplexValue = { real: number; imag: number };
const parseYValues = (data: number[], hasComplexValues: boolean, count: number): ComplexValue[] | number[] => {
  if (hasComplexValues) {
    return data.slice(0, count).map((real, index) => ({
      real,
      imag: data[count + index],
    }));
  }
  return data;
};

const getXUnitsId = (measureType: ANALYTICS_MEASURE_TYPE, rangeType: number): string => {
  if (measureType === ANALYTICS_MEASURE_TYPE.SPECTRUM) {
    return rangeType === 1 || rangeType === 3 ? "3" : "4";
  } else if (measureType === ANALYTICS_MEASURE_TYPE.SIGNAL_FORM) {
    return rangeType === 1 || rangeType === 3 ? "5" : "6";
  }
  return "";
};

export const transformSingleSignalToChart = (
  measure: ISignalDataResponse,
  pointName: string,
  measureType: ANALYTICS_MEASURE_TYPE,
): IChartDataSignal => {
  const { data, rangeType, xEnd, xStart, units } = measure;
  const hasComplexValues = measureType === ANALYTICS_MEASURE_TYPE.SPECTRUM && rangeType === 2;
  const N = hasComplexValues ? data.length / 2 : data.length;

  const xValues = calculateXValues(xStart, xEnd, N);
  const yValues = parseYValues(data, hasComplexValues, N);

  const xUnits = getXUnitsId(measureType, rangeType);
  const yUnits = String(units);

  const items = xValues.map((x, i) => ({
    x,
    y: hasComplexValues ? (yValues[i] as ComplexValue).real : (yValues[i] as number),
  }));

  return {
    idMeasure: measure.idMeasure,
    pointName: measure.pointName,
    pointDescription: measure.pointDescription,
    date: measure.date,
    value1: measure.value1,
    value2: measure.value2,
    idPoint: measure.idPoint,
    measurementName: measure.name,
    measurementDescription: measure.description,
    rangeType: measure.rangeType,
    resolution: measure.resolution,
    alarmType: measure.alarmType,
    rotationFrequencyRpm: measure.rotationFrequencyRpm,
    name: pointName,
    color: lineColors[0],
    items,
    unitsX: xUnits,
    unitsY: yUnits,
    unitsXCode: xUnits ? Number(xUnits) : null,
    unitsYCode: Number(units),
  };
};
